export default __webpack_public_path__ + "static/media/08_photo.2e96b14c.jpg";